import { TextBadgesProps } from "../textBadgesProps";

import { TextBadgesClientWrapperProps } from "./textBadgesClientWrapperProps";

export const textBadgesClientWrapperAdaptor = (
  badgesProps: TextBadgesProps
): TextBadgesClientWrapperProps => {
  return {
    token: badgesProps.token,
    brandToken: badgesProps.brandToken,

    impressionId: badgesProps.impressionId,
    selectedProductOptionToken: badgesProps.selectedProductOptionToken,
    isPromoted: badgesProps.isPromoted,
    promotedBy: badgesProps.promotedBy,
    badgeList: badgesProps.badgeList,
    bestImage: badgesProps.bestImage,
    images: badgesProps.images,
  };
};
